import { SetupWorkerApi, setupWorker } from "msw";

/** The worker is only intended to be used in browser. If we intended to use msw in a node based environment (think jest testing) we must use msw's server setup.
 * See https://davidwcai.medium.com/mock-graphql-and-rest-in-storybook-and-jest-with-msw-78521ec44a9c for a good example.
 */
export const worker: SetupWorkerApi = setupWorker();
